"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _wrappers = require("../../wrappers");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MobileSidebar = function MobileSidebar(_ref) {
  var open = _ref.open,
      toggle = _ref.toggle,
      _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? null : _ref$logo,
      topMenu = _ref.topMenu,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
      bottomMenu = _ref.bottomMenu;
  var theme = (0, _wrappers.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: open ? "block" : "none"
    },
    className: "md:hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed inset-0 z-20 transition-opacity ease-linear duration-300"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute inset-0 bg-gray-600 opacity-75"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed inset-0 flex z-40"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex flex-col max-w-xs w-full transform ease-in-out duration-300"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 right-0 -mr-14 p-1"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: toggle,
    className: "flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "h-6 w-6 text-gray-900",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 18L18 6M6 6l12 12"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 h-0 pt-2 pb-4 overflow-y-auto overflow-x-hidden ".concat(theme.menuBg)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-6 pt-4 pb-8 logo-text gray-900"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/",
    className: "flex-shrink-0 flex items-center ".concat(theme.text)
  }, logo)), /*#__PURE__*/_react["default"].createElement("div", null, topMenu), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "flex-1"
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: page.sectionClass
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      to: page.path,
      icon: page.icon,
      theme: theme,
      className: page.itemClass
    }, page.name));
  })), /*#__PURE__*/_react["default"].createElement("div", null, bottomMenu)))));
};

var DesktopSidebar = function DesktopSidebar(_ref2) {
  var _ref2$menuItems = _ref2.menuItems,
      menuItems = _ref2$menuItems === void 0 ? [] : _ref2$menuItems,
      _ref2$logo = _ref2.logo,
      logo = _ref2$logo === void 0 ? null : _ref2$logo,
      topMenu = _ref2.topMenu,
      bottomMenu = _ref2.bottomMenu;
  var theme = (0, _wrappers.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n\t\t\thidden md:flex z-20\n\t\t\t".concat(theme.sidenavWrapper, "\n\t\t")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex flex-col scrollbar"
  }, !logo ? null : /*#__PURE__*/_react["default"].createElement("div", null, logo), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "flex-1"
  }, topMenu, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: i,
      to: page.path,
      icon: page.icon,
      className: page.className,
      subMenus: (0, _lodash["default"])(page, "subMenus", [])
    }, page.name);
  })), bottomMenu));
};

var SideNav = function SideNav(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MobileSidebar, _extends({
    open: open,
    toggle: setOpen
  }, props)), /*#__PURE__*/_react["default"].createElement(DesktopSidebar, props));
};

var _default = SideNav;
exports["default"] = _default;